/**
 * @generated SignedSource<<464d91ef0e4d5763346a0717372529e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolBalanceWithdrawSubscription$variables = {
  id: string;
};
export type PerpsPoolBalanceWithdrawSubscription$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceWithdrawFragment">;
  } | null | undefined;
};
export type PerpsPoolBalanceWithdrawSubscription = {
  response: PerpsPoolBalanceWithdrawSubscription$data;
  variables: PerpsPoolBalanceWithdrawSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerpsPoolBalanceWithdrawSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PerpsPoolBalanceWithdrawFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerpsPoolBalanceWithdrawSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Balance",
                "kind": "LinkedField",
                "name": "lpSize",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PerpsLiquidityCooldown",
                "kind": "LinkedField",
                "name": "liquidityCooldown",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PerpsAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8808e124bb30c4beb83b0ee4dbdfbba2",
    "id": null,
    "metadata": {},
    "name": "PerpsPoolBalanceWithdrawSubscription",
    "operationKind": "subscription",
    "text": "subscription PerpsPoolBalanceWithdrawSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PerpsPoolBalanceWithdrawFragment\n    id\n  }\n}\n\nfragment PerpsPoolBalanceWithdrawFragment on PerpsAccount {\n  id\n  lpSize {\n    amount\n  }\n  liquidityCooldown {\n    endAt\n    startAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cfc8af2b2516639bffabf2cf2f9e0ee";

export default node;
